import { usePage } from '@/components/providers/PageProvider'
import { type RecRoleType, type RecType } from '@/defs/rec'
import { type RouteType } from '@/defs/route'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { buildRec, getRecSlug } from '@/utils/recUtil'

type ConfigType = Record<RecRoleType, () => RouteType | false>

type Props = {
  rec: RecType
}

export const useCardLink = ({ rec }: Props) => {
  const { buildRelative } = useLinkInternal()
  const { page } = usePage()
  const featured = page?.featured?.rec
  const slug = getRecSlug(rec)
  const role = rec.role || 'card'

  const CONFIG = {
    card: () => ({
      cardSlug: slug,
      colorId: undefined,
      section: 'cardsFeatured',
    }),
    combo: () => ({
      cardSlug: slug,
      colorId: undefined,
      section: 'cardsFeatured',
      tab: 'combos',
    }),
    commander: () => ({
      cardSlug: slug,
      colorId: undefined,
      section: 'commandersFeatured',
    }),
    companion: () => {
      if ((rec.numDecks || 0) < 1) return false
      return {
        section: 'tags',
        tagSlug: `${slug.split('-')[0] || 'name'}-companion`,
      }
    },
    partner: () => ({
      cardSlug: slug,
      section: 'partnersFeatured',
    }),
    partnerPair: () => ({
      cardSlug: getRecSlug(
        buildRec({ ...rec, partnerRef: featured ? { cardId: featured.cardId, name: featured.name } : rec.partnerRef }),
      ),
      colorId: undefined,
      section: 'commandersFeatured',
    }),
  } as const satisfies ConfigType

  const relativeProps = CONFIG[role]()

  if (!relativeProps) return

  return buildRelative({ tab: undefined, ...relativeProps })
}
